module.exports = __webpack_public_path__ + "static/media/dashboard.d811ded8.jpg";